module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-33.efc31a0b.png";